import api from '@/api';
import { SpedSettings } from './sped-settings.types';

const path = '/sped/v1/sped/sped-settings';

export default {
  async settingsByCompanyId(id?: number) {
    const result = (await api.get(`${path}/company/${id}`, null)) as unknown;
    return result as SpedSettings;
  },

  async settingsCreate(companyId: number) {
    const result = (await api.post(`${path}`, { companyId })) as unknown;
    return result as void;
  },

  async settingsDetail(settingId?: number) {
    const result = (await api.get(`${path}/${settingId}`, null)) as unknown;
    return result as SpedSettings;
  },

  async settingsEdit({ id, ...data }: SpedSettings) {
    const result = (await api.put(`${path}/${id}`, data, null)) as unknown;
    return result as void;
  },
};
